import { Typography } from "@mui/material";
import { SxProps, Theme } from '@mui/material/styles';
import {
  ArrayField,
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  DateField,
  FunctionField,
  List,
  NumberField,
  TextField,
  TopToolbar
} from 'react-admin';
import ListPagination from '../../../components/ListPagination';
import { DATE_FORMATER, PERMISSIONS } from '../../../constants';
import { PeriodPointType } from '../../../models/periodPointType';
import { Permission, ReferenceArrayFieldWithLimit } from "../../../components";
import CloneRuleButton from "../CloneRuleButton";

const listActionsSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  background: 'none',
  alignItems: 'center'
};

const warningSx: SxProps<Theme> = {
  '&::before': {
    content: "'* '",
    color: '#ff0000',
    fontSize: 20
  }
};

const ListActions = () => {
  return (
    <TopToolbar sx={listActionsSx}>
      <Typography sx={warningSx}>
        Recomendamos que essas informações estejam presentes no regulamento do programa de fidelidade do posto
      </Typography>
      <CreateButton />
    </TopToolbar>
  );
};

const BulkActionButtons = () => (
  <BulkDeleteButton label="Deletar" />
);

export default props => (
  <List
    title="Limite de Número de Abastecimentos"
    sort={{ field: 'createdAt', order: 'DESC' }}
    pagination={<ListPagination />}
    actions={<ListActions />}
    perPage={25}
    exporter={false}
    {...props}
  >
    <Datagrid rowClick="show" bulkActionButtons={<BulkActionButtons />}>
      <TextField source="identify" label="Código" />
      <ReferenceArrayFieldWithLimit
        source="stationIds"
        reference="stations"
        label="Postos"
        name="posto"
        link="show"
        permission={PERMISSIONS.LIST_STATION}
      />
      <FunctionField
        textAlign="center"
        label="Periodo"
        render={record => PeriodPointType.translateType(record?.period)}
      />
      <NumberField label="Quantidade de Abastecimentos" source="amountFillins" textAlign='center' />
      <DateField
        source="createdAt"
        label="Data de Criação"
        options={DATE_FORMATER}
        sortable={false}
        textAlign='center'
        showTime
      />
      <Permission permission={PERMISSIONS.POINT_RULES}>
        <CloneRuleButton />
      </Permission>
    </Datagrid>
  </List>
)
